import type { StateCreator } from 'zustand';

import { persist } from 'zustand/middleware';
import { useShopInfo } from '~/modules/apps';
import { create } from 'zustand';

// Cache stores by shopId to avoid creating new store every time
const storeCache = new Map<string, any>();

/**
 * Create a store with persist and shopId automatically
 * @param storeName - Store name
 * @param storeFn - Function to create store state and actions
 * @returns Hook to use store
 */
export function createPersistedStoreWithShopId<T>(storeName: string, storeFn: StateCreator<T>) {
  return <U = T>(selector?: (state: T) => U): U => {
    const { shopId } = useShopInfo();
    const cacheKey = `${storeName}-${shopId}`;

    // Check cache before creating new store
    if (!storeCache.has(cacheKey)) {
      const store = create<T>()(
        persist(storeFn, {
          name: cacheKey,
        }),
      );
      storeCache.set(cacheKey, store);
    }

    // Use store from cache
    const store = storeCache.get(cacheKey);
    return store(selector || ((state: T) => state));
  };
}
